import {Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList} from '@angular/core';
import {StandardFormMetaInfo} from './standard-form-meta-info.model';
import { InsparkTemplate } from '@inspark/inspark-components';


@Component({
  selector: 'in-standard-form-builder',
  templateUrl: './standard-form-builder.component.html',
  styleUrls: ['./standard-form-builder.component.scss']
})
export class StandardFormBuilderComponent implements OnInit {
  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  @Input() itemOptions = {};
  @Input() buttons;
  // tslint:disable-next-line:max-line-length
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; deleteFile?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string; view?: string; extcommand?: string} =
    // tslint:disable-next-line:max-line-length
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', deleteFile: 'DELETE FILE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE', upload: 'UPLOAD', view: 'VIEW', extcommand: 'Ext command'};
  // tslint:disable-next-line:max-line-length
  @Input() buttonsColor: { save?: string; create?: string; copy?: string; delete?: string; deleteFile?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string; view?: string; extcommand?: string } =
    // tslint:disable-next-line:max-line-length
    {save: 'primary', create: 'primary', copy: 'primary', delete: 'primary', deleteFile: 'primary', operatingmode: 'primary', timeschedule: 'primary', upload: 'primary', view: 'primary', extcommand: 'primary'};
  @Input() inAction = false;
  @Input() disabled = {save: false, create: false, copy: false, extcommand: false};
  @Input() accept?: string = null;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() view = new EventEmitter<any>();
  @Output() deleteFile = new EventEmitter<any>();
  @Output() operatingmode = new EventEmitter<any>();
  @Output() timeschedule = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Output() extcommand = new EventEmitter<any>();
  @Output() changed = new EventEmitter<any>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  checked = false;

  constructor() {
  }

  ngOnInit() {
    return;
  }

  onSave() {
    this.save.next(this.values);
  }

  onCreate() {
    this.create.next(this.values);
  }

  onDuplicate() {
    this.duplicate.next(this.values);
  }

  onDelete() {
    this.delete.next(this.values);
  }
  onDeleteFile() {
    this.deleteFile.next(this.values);
  }

  onOperatingMode() {
    this.operatingmode.next(this.values);
  }

  onTimeSchedule() {
    this.timeschedule.next(this.values);
  }

  onUpload(event) {
    this.upload.next(event);
  }

  onView(event) {
    this.view.next(event);
  }

  onExtcommand(event) {
    this.extcommand.next(event);
  }
}
